import MyExpApi from "apps/myExperience/enum/MyExpApi";
import { QueryClient } from "react-query";
import { useCopies } from "shared/hooks/useCopies";
import { ApiProgramParticipantManageByOrgAdmin } from "shared/types/ApiProgramParticipantManageByOrgAdmin";
import { ApiProgramParticipantManageByOrgAdminList } from "shared/types/ApiProgramParticipantManageByOrgAdminList";
import { successToast } from "shared/utils/toastNotification";
import { getApiQueryKey, useGetApiData, usePostApiData } from "shared/datalayer";

export function getProgramParticipantForOrgAdminKey(orgAdminProgramParticipantId?: string) {
  return getApiQueryKey(MyExpApi.GET_PROGRAM_PARTICIPANTS_FOR_ORG_ADMIN, { params: { orgAdminProgramParticipantId } });
}

export function useGetProgramParticipantForOrgAdmin({
  orgAdminProgramParticipantId
}: {
  orgAdminProgramParticipantId?: string;
}) {
  return useGetApiData<ApiProgramParticipantManageByOrgAdminList>(
    MyExpApi.GET_PROGRAM_PARTICIPANTS_FOR_ORG_ADMIN,
    {
      params: { orgAdminProgramParticipantId }
    },
    {
      enabled: Boolean(orgAdminProgramParticipantId)
    }
  );
}

/**
 * Called after org admin filling other participant profile, to get latest status
 */
export function refetchOrgAdminProgramParticipantList(queryClient: QueryClient, orgAdminProgramParticipantId?: string) {
  queryClient.refetchQueries(getProgramParticipantForOrgAdminKey(orgAdminProgramParticipantId));
}

export function useManageByOrgAdmin() {
  const copies = useCopies();
  return usePostApiData<ApiProgramParticipantManageByOrgAdmin>(MyExpApi.MANAGE_BY_ORG_ADMIN, {
    onSuccess: () => {
      successToast(copies.get("changes.saved"));
    }
  });
}
